export const FONOTEKA_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export const FONOTEKA_AUDIO_EXTENSIONS = new Set([
  'mp3',
  'wav',
  'flac',
  'ogg',
  'm4a',
  'aac',
  'aiff',
  'aif',
  'wma',
  'opus',
  'webm',
]);

export const FONOTEKA_AUDIO_ACCEPT = [
  'audio/*',
  ...[...FONOTEKA_AUDIO_EXTENSIONS].map((ext) => `.${ext}`),
].join(',');

export function isAudioFile(file: { name: string; type: string }): boolean {
  if (file.type.startsWith('audio/')) return true;
  const dot = file.name.lastIndexOf('.');
  if (dot < 0) return false;
  return FONOTEKA_AUDIO_EXTENSIONS.has(file.name.slice(dot + 1).toLowerCase());
}

export function fileIdentity(file: File): string {
  return `${file.name}:${file.size}:${file.lastModified}`;
}

export type RejectedAudioFile = {
  name: string;
  reason: 'not-audio' | 'too-large';
};

export function collectAudioFiles(
  incoming: Iterable<File>,
  alreadyQueued: ReadonlyArray<File> = [],
): { accepted: File[]; rejected: RejectedAudioFile[] } {
  const seen = new Set(alreadyQueued.map(fileIdentity));
  const accepted: File[] = [];
  const rejected: RejectedAudioFile[] = [];

  for (const file of incoming) {
    if (!isAudioFile(file)) {
      rejected.push({ name: file.name, reason: 'not-audio' });
      continue;
    }
    if (file.size > FONOTEKA_MAX_FILE_SIZE_BYTES) {
      rejected.push({ name: file.name, reason: 'too-large' });
      continue;
    }
    const key = fileIdentity(file);
    if (seen.has(key)) continue;
    seen.add(key);
    accepted.push(file);
  }

  return { accepted, rejected };
}
